import { RouteRecordName } from 'vue-router';

export const ENTITY_TYPES_MAPPING = {
  Knowledge: 'knowledges',
  Case: 'cases',
  Article: 'contents',
  Diagnostic: 'contents',
  Step: 'contents',
  keyStep: 'contents',
  Content: 'contents',
  Answer: 'answer',
} as { [key: string]: string };

export const ROUTE_ENTITY_MAPPING: {
  [key: RouteRecordName]: 'Content' | 'Case';
} = {
  'content-viewer': 'Content',
  'collection-viewer': 'Case',
};

export const DIAG_TYPES = ['Diagnostic', 'Step', 'keyStep'];
